import componentZhHK from './component/zh-HK'
import pageZhHK from './page/zh-HK'

const ZhHK = {
  ...componentZhHK,
  ...pageZhHK
}

export default ZhHK